<template>
  <div class="cso-login-page cso-page">
    <div class="container">
      <div class="logout-header"
           v-if="isDemoThankYouPage">
        <p class="header">{{ $t('logoutPage.header') }}</p>
        <p class="subheader">{{ $t('logoutPage.subheader') }}</p>
      </div>
      <section class="cso-page-structure">
        <cso-login />
      </section>
      <section class="cso-page-structure row hidden-print">
        <cso-teaser-container isOpenArea/>
      </section>
      <section class="cso-page-structure">
        <cso-faq name="FAQ_LOGIN" />
      </section>
      <section class="cso-page-structure"
               v-if="isDemoThankYouPage">
        <div class="row">
          <cso-grid-column s="6"
                           xs="12">
            <cso-box>
              <div class="left-box">
                <h3>{{ $t('logoutPage.advertBoxes.leftBox.header') }}</h3>
                <p>{{ $t('logoutPage.advertBoxes.leftBox.message') }}</p>
                <cso-link :label="$t('logoutPage.advertBoxes.leftBox.button')"
                          :is-button="true"
                          :link="StaticUrls.mobileAppVouchers">
                </cso-link>
              </div>
            </cso-box>
          </cso-grid-column>
          <cso-grid-column s="6"
                           xs="12">
            <cso-box>
              <div class="right-box">
                <h3>{{ $t('logoutPage.advertBoxes.rightBox.header') }}</h3>
                <p>{{ $t('logoutPage.advertBoxes.rightBox.message') }}</p>
                <cso-link :label="$t('logoutPage.advertBoxes.rightBox.button')"
                          :is-button="true"
                          :link="StaticUrls.loginDemo">
                </cso-link>
              </div>
            </cso-box>
          </cso-grid-column>
        </div>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import StaticUrls from '@/common/StaticUrls'

import CsoTeaserContainer from '@/components/core/business/CsoTeaser/CsoTeaserContainer.vue'
import CsoFaq from '@/components/core/business/CsoFaq.vue'
import CsoLogin from '@/components/core/business/CsoLogin/CsoLogin.vue'

export default {
  name: 'CsoLoginRoute',
  components: {
    CsoLogin,
    CsoTeaserContainer,
    CsoFaq
  },
  data () {
    return {
      StaticUrls
    }
  },

  computed: {
    isDemoThankYouPage: function () {
      return location.href ? location.href.indexOf('?demoThankYou') !== -1 : false
    }
  }
}
</script>
<style scoped lang="scss">
.cso-login-page {
  background: $page-wrapper;
  height: 100%;
  max-width: 1300px;
  margin: auto;

  .logout-header {
    padding: 20px;
    text-align: center;
    color: $blue-night;

    .header {
      font-size: 36px;
      line-height: 40px;
      background: none;

      @include xs {
        font-size: 26px;
        line-height: 30px;
      }
    }

    .subheader {
      font-size: 24px;
      line-height: 30px;

      @include xs {
        font-size: 18px;
        line-height: 26px;
      }
    }
  }

  .left-box,
  .right-box {
    color: $blue-night;
    p {
      padding-bottom: 10px;
    }
  }
}
</style>
